import React from 'react'
import { generatePath } from 'react-router-dom'
import { Redirect } from 'react-router-dom'

import { PermissionRequirement } from '@/ducks/auth/auth.types'
import BuyXGetYForm from '@/components-latest/ui/OfferPage/BuyXGetY/BuyXGetYForm'
import CreateCartDiscountForm from '@/components-latest/ui/OfferPage/CreateCartDiscountForm/CreateCartDiscountForm'
import OfferDetailsFormWrapper from '@/components-latest/ui/OfferPage/OfferDetailsFormWrapper'
import { ENVIRONMENT } from '@/constants/env'
import AccountPage from '@/pages-latest/AccountPage/AccountPage'
import OrderPreferencesPage from '@/pages-latest/OrderPreferencesPage'
import BillingPage from '@/pages-latest/BillingPage/BillingPage'
import BranchManagementPage from '@/pages-latest/BranchManagementPage/BranchManagementPage'
import EmailVerificationPage from '@/pages-latest/EmailVerificationPage/EmailVerificationPage'
import LoginDeniedPage from '@/pages-latest/LoginDeniedPage'
import LoginPage from '@/pages-latest/LoginPage'
import MenuPage from '@/pages-latest/MenuPage'
import OffersPage from '@/pages-latest/OffersPage'
import OrdersPage from '@/pages-latest/OrdersPage'
import Page404 from '@/pages-latest/Page404'
import PerformancePage from '@/pages-latest/PerformancePage'
import RegistrationPage from '@/pages-latest/RegistrationPage'
import TestPage from '@/pages-latest/TestPage/TestPage'
import MarketingCampaignsPage from '@/pages-latest/MarketingCampaignsPage'
import MarketingToolsRoutePage from '../../pages-latest/OffersPage/MarketingToolsRoutePage'

import { PATHS } from './paths'

export { PATHS }

export interface RouteConfig {
  element: React.JSX.Element
  path: string
  isProtected?: boolean
  exact?: boolean
  clearLayout?: boolean
  isLatest?: boolean
  forcePublicLayout?: boolean
  requiredPermission?: PermissionRequirement
}

export const routeConfigs: RouteConfig[] = [
  {
    path: '/',
    exact: true,
        element: (
          // @ts-ignore
          <Redirect to={PATHS.ORDERS} />
        )
  },
  {
    path: PATHS.ORDERS,
    exact: true,
    isProtected: true,
        element: (
          // @ts-ignore
          <Redirect to={generatePath(PATHS.ORDERS_BY_STATUS, { status: 'new' })} />
        )
  },
  {
    clearLayout: true,
    path: PATHS.LOGIN,
    exact: true,
    isProtected: false,
    element: <LoginPage />
  },
  {
    path: PATHS.ORDERS_BY_STATUS,
    isProtected: true,
    element: <OrdersPage />
  },
  {
    path: PATHS.MENU,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'menu', operation: 'view' },
    element: <MenuPage />
  },
  {
    path: PATHS.OFFERS,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: (
      // @ts-ignore
      <Redirect
        to={generatePath(PATHS.OFFERS_BY_ID, { id: 'item_discount' })}
      />
    )
  },

  {
    path: PATHS.OFFERS_BY_ID,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: <OffersPage />
  },
  {
    path: PATHS.OFFERS_CREATE,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: <OfferDetailsFormWrapper />
  },
  {
    path: PATHS.OFFERS_CART_DISCOUNT_CREATE,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: <CreateCartDiscountForm />
  },
  {
    path: PATHS.OFFERS_BUYX_GETY_CREATE,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: <BuyXGetYForm />
  },
  {
    path: PATHS.BRANCH_BUSINESS_HOURS,
    isProtected: true,
    requiredPermission: { resource: 'business_hours', operation: 'view' },
    element: <BranchManagementPage />
  },
  {
    path: PATHS.MARKETING_CAMPAIGNS,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: <MarketingCampaignsPage />
  },
  {
    path: PATHS.MARKETING_TOOLS,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'offers', operation: 'manage' },
    element: <MarketingToolsRoutePage />
  },
  {
    path: PATHS.PERFORMANCE,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'performance', operation: 'view' },
    element: (
      // @ts-ignore
      <Redirect to={generatePath(PATHS.PERFORMANCE_BY_ID, { id: 'orders' })} />
    )
  },
  {
    path: PATHS.PERFORMANCE_BY_ID,
    isProtected: true,
    requiredPermission: { resource: 'performance', operation: 'view' },
    element: <PerformancePage />
  },
  {
    path: PATHS.BILLING,
    exact: true,
    isProtected: true,
    requiredPermission: { resource: 'billing', operation: 'view' },
    element: <BillingPage />
  },
  {
    path: PATHS.ACCOUNT_ORDER_PREFERENCES,
    exact: true,
    isProtected: true,
    element: <OrderPreferencesPage />
  },
  {
    path: PATHS.ACCOUNT,
    exact: true,
    isProtected: true,
    element: <AccountPage />
  },
  {
    path: PATHS.LOGIN_DENIED,
    exact: true,
    isProtected: false,
    forcePublicLayout: true,
    element: <LoginDeniedPage />
  },
  {
    path: PATHS.REGISTRATION,
    exact: true,
    clearLayout: true,
    isProtected: false,
    element: <RegistrationPage />
  },
  {
    path: PATHS.EMAIL_VERIFICATION,
    exact: true,
    clearLayout: true,
    isProtected: false,
    element: <EmailVerificationPage />
  },
  ...(ENVIRONMENT !== 'production'
    ? [
        {
          path: PATHS.TEST_COMPONENTS,
          exact: true,
          isProtected: false,
          clearLayout: true,
          element: <TestPage />
        }
      ]
    : []),

  { path: '*', element: <Page404 /> }
]

export default routeConfigs
